import React, { useState, useRef } from "react";
import Helmet from "react-helmet";
import { appName } from "../app.json";
import * as qs from "query-string";
import { NEW_PASSWORD } from "../queries/staff.query";
import { useMutation } from "@apollo/react-hooks";
import LoadingSpinner from "../partials/loading.jsx";
import AlertMessage from "../partials/alertMessage.jsx";
import { Redirect } from "react-router-dom";

const NewPasswordForm = ({ location }) => {
  // local state
  const [message, setMessage] = useState(null);
  const [failed, setFailed] = useState(false);

  //  local reference
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  // get id and email
  const { id, email, ref } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });
  const [sendFunc, { loading }] = useMutation(NEW_PASSWORD, {
    onCompleted: (data) => {
      if (data.UpdateNewPassword) {
        setMessage("Password updated successfully! Login to continue");
        setFailed(false);
      }
    },
    onError: (error) => {
      setMessage(error.message);
      setFailed(true);
    },
  });

  if (!id || !ref || !email) {
    return <Redirect to="/login" />;
  }
  return (
    <>
      <Helmet>
        <title>New Password Form | {appName}</title>
        <link rel="stylesheet" href="../main/css/extra_pages.css"></link>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.2.0/css/material-design-iconic-font.min.css"
        ></link>
      </Helmet>
      <div className="login-container">
        <div className="logo-left">clinicalspec</div>
        <div className="row justify-content-center">
          <div className="wrap-login100" style={{ margin: "100px 0 10px 0" }}>
            <AlertMessage message={message} failed={failed} />
            <form
              className="login100-form validate-form"
              onSubmit={(e) => {
                e.preventDefault();
                const pass = passwordRef.current.value;
                const confirmP = confirmPasswordRef.current.value;
                if (pass === confirmP) {
                  setMessage(null);
                  sendFunc({
                    variables: {
                      id: id,
                      password: pass,
                    },
                  });
                } else {
                  setMessage("Password do not match!");
                  setFailed(true);
                }
              }}
            >
              <span className="login100-form-logo">
                <img alt="logo" src="/assets/img/logo.jpeg" />
              </span>

              <p className="text-center txt-small-heading">New Password Form</p>
              <div
                className="wrap-input100 validate-input"
                data-validate="Enter new password"
              >
                <input
                  className="input100"
                  type="password"
                  required
                  name="newPassword"
                  ref={passwordRef}
                  placeholder="enter new password"
                />
                <span
                  className="focus-input100"
                  data-placeholder="&#xf207;"
                ></span>
              </div>
              <div
                className="wrap-input100 validate-input"
                data-validate="Confirm password"
              >
                <input
                  className="input100"
                  type="password"
                  required
                  ref={confirmPasswordRef}
                  name="confirmPassword"
                  placeholder="confirm password"
                />
                <span
                  className="focus-input100"
                  data-placeholder="&#xf207;"
                ></span>
              </div>
              <div className="text-center">
                <LoadingSpinner loading={loading} />
              </div>
              <div className="container-login100-form-btn">
                <button type="submit" className="login100-form-btn">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPasswordForm;
